export const ENDPOINT = {
    /* IP WHITELISTING */

    GET_ALL_IPS: "whitelist/lender-ip",
    POST_LENDER_IP: "whitelist/lender-ip",
    PUT_RBI_IP: "whitelist/lender-ip",
    POST_IP_DOCUMENT: "whitelist/ip/security-doc",
};
